import { reduxForm } from 'redux-form';
import ForgotPasswordContainer from './ForgotPasswordContainer';
import ForgotPasswordValidator from '../../common/validation/ForgotPasswordValidator';

const config = {
  form: 'forgotPassword',
  destroyOnUnmount: true,
  validate: ForgotPasswordValidator,
  initialValues: {
    email: ''
  },
  enableReinitialize: true
};

const ForgotPasswordFormContainer = reduxForm(config)(ForgotPasswordContainer);

export default ForgotPasswordFormContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ForgotPasswordFormContainer.js
 **/